import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import locale from 'element-ui/lib/locale/lang/id';

Vue.use(ElementUI, {locale});

import { library } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'; 
import { faUserSecret, faHome, faFileAlt, faRunning, faClipboardList, faShieldAlt, faGavel, faUsers, faUserCircle, faSignOutAlt, faCheckCircle, faSpinner, faSignature, faArchive, faQrcode, faArrowRight, faClipboard, faNewspaper, faUser, faUserCog, faUserShield, faSatelliteDish, faUniversalAccess, faEye, faArrowLeft, faChevronLeft, faClock, faUserSlash, faUserTag, faSyncAlt, faHistory, faFilter, faFileExcel, faPlus, faMobileAlt, faCogs, faTrash, faSearch, faTimesCircle, faBan, faTimes, faEyeSlash, faBars } from '@fortawesome/free-solid-svg-icons'
import { faFileLines } from '@fortawesome/free-regular-svg-icons';

library.add({ faUserSecret, faHome, faFileAlt, faRunning, faClipboardList, faShieldAlt, faGavel, faUsers, faUserCircle, faSignOutAlt, faCheckCircle, faSpinner, faSignature, faArchive, faQrcode, faArrowRight, faClipboard, faNewspaper, faFileLines, faUser, faUserCog, faUserShield, faSatelliteDish, faUniversalAccess, faEye, faArrowLeft, faChevronLeft, faClock, faUserSlash, faUserTag, faSyncAlt, faHistory, faFilter, faFileExcel, faPlus, faMobileAlt, faCogs, faTrash, faSearch, faTimesCircle, faBan, faTimes, faEyeSlash, faBars });
Vue.component('font-awesome-icon', FontAwesomeIcon)

import VueGeolocation from 'vue-browser-geolocation'
Vue.use(VueGeolocation);

import excel from 'vue-excel-export'
Vue.use(excel)

// Import maintenance config
import { isFatalError, isExcludedRoute, maintenanceConfig } from './utils/maintenanceConfig'

import PageMonitor from './plugins/pageMonitor'
// Vue.use(PageMonitor) // Disabled for now

Vue.config.productionTip = false

// Global error handler untuk menangani error yang tidak tertangkap
Vue.config.errorHandler = (err, vm, info) => {
  console.error('Global error:', err, info)
  
  // Hanya redirect ke maintenance untuk error fatal berdasarkan konfigurasi
  const routePath = vm.$route?.path || ''
  
  if (isFatalError(err, info) && !isExcludedRoute(routePath)) {
    console.warn('Fatal error detected, redirecting to maintenance')
    // Redirect ke maintenance setelah delay yang dikonfigurasi
    setTimeout(() => {
      if (vm.$router) {
        vm.$router.push('/maintenance').catch(() => {
          // Fallback jika router push gagal
          window.location.href = '/maintenance'
        })
      }
    }, maintenanceConfig.redirectDelay)
  }
}

// Handle unhandled promise rejections
window.addEventListener('unhandledrejection', event => {
  console.error('Unhandled promise rejection:', event.reason)
  
  // Gunakan konfigurasi maintenance untuk menentukan error kritis
  const isCriticalError = isFatalError(event.reason)
  
  if (isCriticalError) {
    event.preventDefault()
  }
  
  // Untuk error navigation router atau authentication, biarkan handle normal
})

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
